import axios from "axios";
import { useEffect, useState } from "react";
import delicon from './images/cross.png';
import editicon from './images/st5.png';
export default function BioWaste()
{
    let [formData,setFormData]=useState({id:"",qty:"",bdate:"",btime:"",bnote:""});
    let [wasteData,setWasteData]=useState([]);
    let [msg,setMsg]=useState("");
    function doSave(event)
    {
        
        event.preventDefault();
        if(window.confirm("Are you sure?"))
        {
            let config={headers:{"Content-Type":"application/json",}};
            let url="biowaste.php?opr=S";
            if(formData.id!="") url="biowaste.php?opr=U";
            axios.post(process.env.REACT_APP_APIURL+url,JSON.stringify(formData)).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert("Data Saved Successfully")
                    setFormData({id:"",qty:"",bdate:"",btime:"",bnote:""});
                    loadWasteData();
                }
                else
                {
                    alert("Oops!!!");
                }
            });
        }
    }
    function changeEvent(event)
    {
        if(event.target.id=="txtQty") setFormData({...formData,qty:event.target.value});
        if(event.target.id=="txtDate") setFormData({...formData,bdate:event.target.value});
        if(event.target.id=="txtTime") setFormData({...formData,btime:event.target.value});
        if(event.target.id=="txtNote") setFormData({...formData,bnote:event.target.value});
    }
    function viewData(id)
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"biowaste.php?id="+id,config).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setFormData({id:reply.data.data.id,qty:reply.data.data.id,bdate:reply.data.data.bdate.split("-").reverse().join("-"),btime:reply.data.data.btime,bnote:reply.data.data.bnote});
            }
        });
    }
    function deleteData(id)
    {
        if(window.confirm("Are you sure?"))
        {
            let config={headers:{"Content-Type":"application/json",}};

            axios.post(process.env.REACT_APP_APIURL+"biowaste.php?opr=D",JSON.stringify({id:id})).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert("Data Deleted Successfully")
                    setFormData({id:"",qty:"",bdate:"",btime:"",bnote:""});
                    loadWasteData();
                }
                else
                {
                    alert("Oops!!!");
                }
            });
        }
    }
    function clearData(event)
    {
        setFormData({id:"",qty:"",bdate:"",btime:"",bnote:""});
    }
    function loadWasteData()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"biowaste.php",config).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setWasteData(reply.data.data);
            }
        });
    }
    useEffect(()=>{loadWasteData()},[]);
    return(
        <div className="container">
            <div className="card mt-3 shadow">
                <div className="card-header text-center text-white bg-primary">
                    <b>Bio Waste Management</b><br/>
                    (Disposable is Handled by Synergy Waste Management)
                </div>
                <div className="card-body p-3">
                    <div className="border rounded p-2">
                        <form onSubmit={doSave}>
                            <div className="row">                            
                                <input type="hidden" id="txtId" value={formData.id}  />                            
                                <div className="form-group col-xxl-3 col-xl-3 col-lg-3 col-6">
                                    <label>Qty (Gm)</label>
                                    <input type="number" id="txtQty"  value={formData.qty} onChange={changeEvent} className="form-control" required />
                                </div>
                                <div className="form-group col-xxl-3 col-xl-3 col-lg-3 col-6">
                                    <label>Date</label>
                                    <input type="date" id="txtDate"  value={formData.bdate} onChange={changeEvent}  className="form-control"  required/>
                                </div>
                                <div className="form-group col-xxl-3 col-xl-3 col-lg-3 col-6">
                                    <label>Time</label>
                                    <input type="time" id="txtTime"  value={formData.btime} onChange={changeEvent}  className="form-control"  required/>
                                </div>
                                <div className="form-group col-xxl-3 col-xl-3 col-lg-3 col-6">
                                    <label>Note/Comment</label>
                                    <input type="text" id="txtNote"  value={formData.bnote} onChange={changeEvent}  className="form-control" />
                                </div>
                            </div>
                            <input type="submit" value="Save / Update" className="btn btn-primary mt-3"  /> <input type="button" onClick={clearData} value="Clear" className="btn btn-info mt-3"  />
                            <span className="ms-3 text-danger">{msg}</span>
                        </form>
                    </div>
                    <hr/>
                    <div style={{overflow:'auto',fontSize:'12px'}}>
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Qty</th>
                                    <th>Date of Dispose</th>
                                    <th>Time of Dispose</th>
                                    <th>Comment</th>
                                    <th className="text-center">View</th>
                                    <th className="text-center">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {wasteData.map((e,i)=>
                                    <tr key={e.id}>
                                        <td >{i+1}</td>
                                        <td>{e.qty}</td>
                                        <td>{e.bdate}</td>
                                        <td>{e.btime}</td>
                                        <td>{e.bnote}</td>
                                        <td className="text-center"><img src={editicon} onClick={()=>{viewData(e.id)}} style={{cursor:'pointer',width:'20px'}} /></td>
                                        <td className="text-center"><img src={delicon}  onClick={()=>{deleteData(e.id)}} style={{cursor:'pointer',width:'20px'}} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}